import ClassNameGenerator from '../ClassNameGenerator';
export const globalStateClasses = {
  active: 'active',
  checked: 'checked',
  completed: 'completed',
  disabled: 'disabled',
  error: 'error',
  expanded: 'expanded',
  focused: 'focused',
  focusVisible: 'focusVisible',
  open: 'open',
  readOnly: 'readOnly',
  required: 'required',
  selected: 'selected'
};
export default function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator.generate(componentName)}-${slot}`;
}
export function isGlobalState(slot) {
  return globalStateClasses[slot] !== undefined;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/x-date-pickers/node_modules/@mui/utils/generateUtilityClass/generateUtilityClass.js
// module id = 1419
// module chunks = 0